export interface Article {
  id: string
  titleAr: string
  titleEn: string
  excerptAr: string
  excerptEn: string
  contentAr: string
  contentEn: string
  image: string
  date: string
  authorAr: string
  authorEn: string
  readTime: number
  category: string
}

export const articles: Article[] = [
  {
    id: '1',
    titleAr: 'باب المندب وأثره على مسارات الشحن البري في 2026',
    titleEn: 'Bab al-Mandab and Its Impact on Land Shipping Routes in 2026',
    excerptAr: 'يُعيد ممر باب المندب رسم خريطة التجارة الدولية، مما يجعل مسارات الشحن البري البديلة عبر مصر أكثر أهمية من أي وقت مضى.',
    excerptEn: 'The Bab al-Mandab strait is reshaping the map of international trade, making alternative overland shipping routes through Egypt more important than ever.',
    contentAr: `يُعدّ مضيق باب المندب أحد أضيق نقاط الاختناق البحرية في العالم، إذ يفصل بين القارة الأفريقية وشبه الجزيرة العربية عند مدخل البحر الأحمر الجنوبي. وفي ظل التقلبات التي شهدتها حركة الملاحة في هذا الممر خلال الفترة الأخيرة، باتت شركات الشحن الكبرى تبحث بجدية عن مسارات بديلة أكثر استقراراً وأماناً.

**أثر باب المندب على سلاسل التوريد**

لجأت كثير من شركات الشحن العالمية إلى تحويل رحلاتها حول رأس الرجاء الصالح، مما أضاف ما بين 10 إلى 15 يوماً على أوقات الشحن وزاد التكاليف بشكل ملحوظ. هذا الواقع الجديد فتح الباب واسعاً أمام الشحن البري والنقل متعدد الوسائط كحلول عملية وفعّالة.

**المسارات البرية عبر مصر كبديل استراتيجي**

تمتلك مصر شبكة طرق برية وسككية مميزة تربط موانئها على البحر الأبيض المتوسط بموانئها على البحر الأحمر، مما يجعلها ممراً لوجستياً برياً فريداً. طريق الإسكندرية والسويس يربط البحر الأبيض المتوسط بمدخل البحر الأحمر مروراً بالقاهرة، وطريق دمياط والعين السخنة يوفر بديلاً مرناً للبضائع الواردة من أوروبا المتجهة لدول الخليج، فضلاً عن مشروع ممر التنمية الاستراتيجي الذي يدمج النقل البري والسككي والنهري في منظومة واحدة.

**مزايا الشحن البري في هذا السياق**

الشحن البري عبر مصر يُتيح تجنب مخاطر الملاحة البحرية في المضايق، مع أوقات تسليم أكثر قابلية للتنبؤ وتكاليف تنافسية مقارنة بتحويل المسارات البحرية البعيدة، إلى جانب مرونة أكبر في التعامل مع أحجام شحن متنوعة.

**فرص النمو لشركات اللوجستيات المصرية**

يُتيح هذا التحول فرصة ذهبية لشركات الشحن البري والنقل متعدد الوسائط في مصر لتعزيز حضورها وتوسيع نطاق خدماتها. شليل للخدمات اللوجستية تواكب هذا التحول بتقديم حلول شحن برية متكاملة تربط الموانئ المصرية بدول المنطقة.

التغيرات في حركة الملاحة عبر باب المندب ليست مجرد تحدٍّ مؤقت، بل هي محفّز حقيقي لإعادة هيكلة سلاسل التوريد الإقليمية لصالح المسارات البرية المصرية.`,
    contentEn: `The Bab al-Mandab strait is one of the world's narrowest maritime chokepoints, separating the African continent from the Arabian Peninsula at the southern entrance of the Red Sea. In light of recent disruptions to shipping traffic through this passage, major shipping companies are seriously exploring alternative routes that are more stable and secure.

**Bab al-Mandab's Impact on Supply Chains**

Many global shipping companies have rerouted their voyages around the Cape of Good Hope, adding 10 to 15 days to shipping times and significantly increasing costs. This new reality has opened the door wide for overland shipping and multimodal transport as practical and effective solutions.

**Overland Routes Through Egypt as a Strategic Alternative**

Egypt possesses a distinctive road and rail network linking its Mediterranean ports to its Red Sea ports, making it a unique overland logistics corridor. The Alexandria-Suez route connects the Mediterranean to the Red Sea entrance via Cairo, while the Damietta-Ain Sokhna route provides a flexible alternative for goods arriving from Europe heading to Gulf countries. The Development Corridor project further integrates road, rail, and river transport in a single system.

**Advantages of Overland Shipping in This Context**

Overland shipping through Egypt allows companies to avoid maritime navigation risks in straits, with more predictable delivery times and competitive costs compared to lengthy maritime rerouting. It also offers greater flexibility in handling varied shipment volumes.

**Growth Opportunities for Egyptian Logistics Companies**

This shift presents a golden opportunity for Egyptian overland shipping and multimodal transport companies to strengthen their presence and expand their services. Shalil Logistics keeps pace with this transformation by offering integrated overland shipping solutions connecting Egyptian ports to countries in the region.

Changes in shipping traffic through Bab al-Mandab restructure regional supply chains in favor of Egyptian overland routes.`,
    image: '/assets/images/story-shipment.jpg',
    date: '2026-03-15',
    authorAr: 'فريق شليل',
    authorEn: 'Shalil Team',
    readTime: 6,
    category: 'land',
  },
  {
    id: '2',
    titleAr: 'الشحن البري في مصر: دليلك لنقل البضائع براً',
    titleEn: 'Overland Shipping in Egypt: Your Guide to Land Freight',
    excerptAr: 'الشحن البري يُمثّل العمود الفقري للتجارة الداخلية والإقليمية. تعرف على أنواعه ومتى يكون الخيار الأمثل.',
    excerptEn: 'Overland shipping is the backbone of domestic and regional trade. Learn about its types and when it is the optimal choice.',
    contentAr: `يُعدّ الشحن البري الخيار الأول لنقل البضائع داخل مصر وإلى الدول المجاورة، نظراً لمرونته العالية وتكلفته التنافسية مقارنة بالشحن الجوي، وقدرته على الوصول إلى مناطق لا تغطيها الموانئ.

**أنواع الشحن البري**

**الشاحنات الكاملة**

تُخصَّص الشاحنة بالكامل لبضائع عميل واحد. هذا النوع مثالي للكميات الكبيرة ويوفر أماناً أعلى وأوقات تسليم أسرع، إذ لا تتوقف الشاحنة في أي نقطة وسيطة.

**الشحن الجزئي**

تتشارك عدة شحنات نفس الشاحنة. يناسب الكميات الصغيرة ويُخفّض التكاليف بشكل كبير، وهو خيار مناسب للشركات التي لا تملك ما يكفي لملء شاحنة كاملة.

**النقل متعدد الوسائط**

يجمع بين الشحن البري والبحري أو الجوي في رحلة واحدة متكاملة، ويُستخدم لتحقيق أقصى كفاءة في الوقت والتكلفة، خاصة عند الشحن لمسافات طويلة تتجاوز الحدود.

**الناقلات المتخصصة**

مخصصة للبضائع الخاصة كالمركبات الثقيلة والمعدات الصناعية والبضائع الخطرة التي تتطلب معدات ومتطلبات ترخيص خاصة.

**المسارات البرية الرئيسية من مصر**

تربط مصر بشبكة طرق برية متعددة بدول الجوار؛ إذ يمتد طريق الساحل الشمالي نحو ليبيا، وطريق الصحراء الغربية نحو السودان، فيما تتصل مصر بالأردن والمملكة العربية السعودية عبر سيناء ومنفذ نويبع البحري. أما الشبكة الداخلية فتربط القاهرة بجميع المحافظات المصرية.

**لماذا تختار الشحن البري؟**

الشحن البري يمنحك مرونة في مواعيد الإقلاع والوصول، مع خدمة من الباب للباب دون الحاجة لتغيير وسيلة النقل. تكلفته أقل للمسافات المتوسطة، وهو مناسب للبضائع الحساسة للتبريد عبر الشاحنات المبردة، ولا يستلزم وجود ميناء أو مطار قريب من موقع البضاعة.

تواصل مع فريق شليل للحصول على أفضل حلول الشحن البري لاحتياجاتك.`,
    contentEn: `Overland shipping is the first choice for transporting goods within Egypt and to neighboring countries, thanks to its high flexibility, competitive cost compared to air freight, and its ability to reach areas not covered by ports.

**Types of Overland Shipping**

**Full Truck Load**

The truck is dedicated entirely to one client's goods. This type is ideal for large quantities, offering higher security and faster delivery times since the truck makes no intermediate stops.

**Less than Truck Load**

Multiple shipments share the same truck. Suitable for small quantities and significantly reduces costs. It is a good option for companies that do not have enough cargo to fill an entire truck.

**Multimodal Transport**

Combines overland and sea or air shipping in one integrated journey, used to achieve maximum efficiency in time and cost, especially for long-distance shipments crossing borders.

**Specialized Carriers**

Dedicated to special cargo such as heavy vehicles, industrial equipment, and hazardous goods that require specific equipment and special licensing requirements.

**Main Overland Routes from Egypt**

Egypt is connected to neighboring countries through multiple overland routes. The North Coast highway extends toward Libya, the Western Desert road leads to Sudan, and Egypt connects to Jordan and Saudi Arabia via Sinai and the Nuweiba maritime crossing. The domestic network connects Cairo to all Egyptian governorates.

**Why Choose Overland Shipping?**

Overland shipping gives you flexibility in departure and arrival schedules, with door-to-door service without the need to change transport mode. Its cost is lower for medium distances, and it is suitable for temperature-sensitive goods via refrigerated trucks, without requiring a nearby port or airport.

Contact the Shalil team for the best overland shipping solutions for your needs.`,
    image: '/assets/images/hero-shipping.jpg',
    date: '2026-02-20',
    authorAr: 'فريق شليل',
    authorEn: 'Shalil Team',
    readTime: 6,
    category: 'land',
  },
  {
    id: '3',
    titleAr: 'النقل متعدد الوسائط: مستقبل اللوجستيات في مصر',
    titleEn: 'Multimodal Transport: The Future of Logistics in Egypt',
    excerptAr: 'دمج الشحن البري مع البحري والجوي في منظومة واحدة يُحقق أعلى كفاءة وأقل تكلفة. تعرّف على كيفية الاستفادة منه.',
    excerptEn: 'Combining land, sea, and air shipping in one system achieves maximum efficiency at the lowest cost. Learn how to benefit from it.',
    contentAr: `النقل متعدد الوسائط هو استخدام أكثر من وسيلة نقل واحدة كالشاحنة والسفينة والقطار في رحلة شحن واحدة مُنسَّقة بعقد لوجستي موحّد. وهو الاتجاه الأسرع نمواً في قطاع اللوجستيات العالمي والمصري على حدٍّ سواء.

**لماذا النقل متعدد الوسائط؟**

يجمع هذا النوع من الشحن أفضل ما في كل وسيلة نقل؛ السرعة من الشحن الجوي، والاقتصاد من الشحن البحري، والوصول الواسع من الشحن البري. بدلاً من الاعتماد على وسيلة واحدة تُحدّ من خيارات الشركة، يُتيح النقل متعدد الوسائط تصميم مسار مُخصَّص لكل شحنة وفق احتياجاتها.

**الإطار اللوجستي المصري المثالي للنقل متعدد الوسائط**

تتمتع مصر بموقع جغرافي استثنائي يجعلها مركزاً طبيعياً للنقل متعدد الوسائط. ميناء العين السخنة يربط البحر الأحمر بالشبكة البرية نحو الداخل المصري والدول المجاورة، بينما يخدم ميناء الإسكندرية الصادرات والواردات الأوروبية ثم يُوزّعها برياً. شبكة السكك الحديدية المصرية تمتد عبر أهم المحاور الاقتصادية وتُشكّل رافداً قوياً لتخفيف الضغط على الطرق البرية. والمنطقة الاقتصادية لقناة السويس توفر منصات لوجستية متكاملة تُيسّر التحوّل بين وسائل النقل المختلفة.

**نموذج عملي: الشحن من أوروبا إلى دول الخليج عبر مصر**

البضاعة تصل بحراً إلى ميناء الإسكندرية أو دمياط، ثم تُنقل برياً بالشاحنات إلى ميناء العين السخنة أو السويس، ومن هناك تُعاد شحنها بحراً نحو موانئ الخليج. هذا المسار يوفر الوقت والتكلفة مقارنة بالإبحار حول أفريقيا أو انتظار ازدحام قناة السويس.

**دور شليل في منظومة النقل متعدد الوسائط**

نقدم تنسيقاً كاملاً بين الوسائل المختلفة تحت مظلة خدمة واحدة متكاملة، بدءاً من الاستلام وحتى التسليم النهائي، مع متابعة مستمرة لكل مرحلة من مراحل الرحلة اللوجستية.`,
    contentEn: `Multimodal transport is the use of more than one mode of transport such as truck, ship, and train in a single coordinated shipping journey under a unified logistics contract. It is the fastest-growing trend in both the global and Egyptian logistics sectors.

**Why Multimodal Transport?**

This type of shipping combines the best of each transport mode: the speed of air freight, the economy of sea freight, and the wide reach of overland freight. Rather than relying on a single mode that limits a company's options, multimodal transport allows designing a customized route for each shipment according to its needs.

**Egypt's Ideal Logistics Framework for Multimodal Transport**

Egypt enjoys an exceptional geographic location that makes it a natural hub for multimodal transport. Ain Sokhna Port connects the Red Sea to the overland network toward the Egyptian interior and neighboring countries, while Alexandria Port serves European imports and exports and then distributes them overland. Egypt's rail network extends through the most important economic corridors, forming a powerful support to reduce pressure on road networks. The Suez Canal Economic Zone provides integrated logistics platforms that facilitate the transition between different modes of transport.

**Practical Example: Shipping from Europe to Gulf Countries via Egypt**

Goods arrive by sea at Alexandria or Damietta Port, then are transported overland by truck to Ain Sokhna or Suez Port, and from there reshipped by sea toward Gulf ports. This route saves time and cost compared to sailing around Africa or waiting for Suez Canal congestion.

**Shalil's Role in the Multimodal Transport System**

We provide full coordination between different modes under one integrated service, from pickup to final delivery, with continuous follow-up at every stage of the logistics journey.`,
    image: '/assets/images/hero-home-1.jpg',
    date: '2026-01-10',
    authorAr: 'فريق شليل',
    authorEn: 'Shalil Team',
    readTime: 5,
    category: 'land',
  },
  {
    id: '4',
    titleAr: 'التخليص الجمركي في مصر: دليلك الشامل',
    titleEn: 'Customs Clearance in Egypt: Your Comprehensive Guide',
    excerptAr: 'التخليص الجمركي يمكن أن يكون تحدياً كبيراً للمستوردين والمصدرين. هذا الدليل يشرح كل خطوة بالتفصيل.',
    excerptEn: 'Customs clearance can be a major challenge for importers and exporters. This guide explains every step in detail.',
    contentAr: `التخليص الجمركي في مصر يمر بمراحل محددة يجب فهمها جيداً لتجنب التأخير والغرامات. إليك الدليل الشامل:

**المرحلة الأولى: إعداد الوثائق**

قبل وصول الشحنة، يجب تجهيز مجموعة من الوثائق الأساسية تشمل بوليصة الشحن والفاتورة التجارية وقائمة التعبئة وشهادة المنشأ ووثائق التأمين. أي نقص في هذه الوثائق يُعرّض الشحنة للتوقف وقد يُفضي إلى غرامات تأخير مكلفة.

**المرحلة الثانية: تسجيل البيان الجمركي**

يتم تسجيل البيان عبر المنظومة الجمركية الإلكترونية NAFEZA، التي تتيح التسجيل المسبق قبل وصول البضاعة بأيام. هذا التسجيل المبكر يُقلّل وقت الانتظار في الميناء ويُسهم في تسريع عملية الإفراج الجمركي.

**المرحلة الثالثة: الفحص والمعاينة**

يُصنّف الجمارك المصري الشحنات إلى ثلاث قنوات. القناة الخضراء تعني إفراجاً فورياً دون فحص. القناة البرتقالية تستلزم مراجعة الوثائق فقط. القناة الحمراء تتطلب فحصاً مادياً للبضاعة. تصنيف الشحنة في القناة المناسبة يعتمد على طبيعة البضاعة وسجل المستورد.

**المرحلة الرابعة: سداد الرسوم والإفراج**

بعد الموافقة، تُسدَّد رسوم الجمارك والضرائب المستحقة ثم يُفرَج عن البضاعة. من المهم التحقق من صحة الحساب الجمركي قبل السداد لتجنب أي خلافات لاحقة.

**نصائح مهمة**

تأكد من دقة جميع الوثائق قبل تسجيلها، واستعن بوكيل جمارك معتمد ذي خبرة يعرف جيداً إجراءات الميناء الذي تستخدمه. سجّل مبكراً عبر NAFEZA لتجنب تأخيرات اللحظة الأخيرة، واحتفظ دائماً بنسخ احتياطية من جميع الوثائق المقدمة.`,
    contentEn: `Customs clearance in Egypt goes through specific stages that must be well understood to avoid delays and penalties. Here is the comprehensive guide:

**Stage One: Document Preparation**

Before the shipment arrives, a set of essential documents must be prepared, including the Bill of Lading, commercial invoice, packing list, certificate of origin, and insurance documents. Any shortage in these documents exposes the shipment to a halt and may lead to costly delay penalties.

**Stage Two: Customs Declaration Registration**

The declaration is registered through the NAFEZA electronic customs system, which allows pre-registration days before goods arrive. This early registration reduces waiting time at the port and helps speed up the customs clearance process.

**Stage Three: Inspection and Examination**

Egyptian Customs classifies shipments into three channels. The Green Channel means immediate release without inspection. The Orange Channel requires document review only. The Red Channel requires a physical inspection of the goods. The classification of a shipment into the appropriate channel depends on the nature of the goods and the importer's track record.

**Stage Four: Fee Payment and Release**

After approval, customs duties and applicable taxes are paid and then the goods are released. It is important to verify the customs calculation before payment to avoid any subsequent disputes.

**Important Tips**

Ensure all documents are accurate before registering them, and use an experienced licensed customs broker who is well familiar with the procedures of the port you are using. Register early through NAFEZA to avoid last-minute delays, and always keep backup copies of all documents submitted.`,
    image: '/assets/images/hero-home-2.jpg',
    date: '2025-12-05',
    authorAr: 'فريق شليل',
    authorEn: 'Shalil Team',
    readTime: 7,
    category: 'customs',
  },
  {
    id: '5',
    titleAr: 'سلسلة التبريد البري: نقل البضائع المبردة في مصر',
    titleEn: 'Cold Chain Land Logistics: Refrigerated Cargo Transport in Egypt',
    excerptAr: 'الحفاظ على درجة حرارة المنتجات الغذائية والدوائية أثناء النقل البري يتطلب أسطولاً متخصصاً ونظاماً دقيقاً للمراقبة.',
    excerptEn: 'Maintaining the temperature of food and pharmaceutical products during land transport requires a specialized fleet and a precise monitoring system.',
    contentAr: `سلسلة التبريد هي منظومة متكاملة تضمن بقاء المنتجات الحساسة للحرارة كالأغذية الطازجة والمجمدة والأدوية واللقاحات في درجة الحرارة المطلوبة طوال رحلة النقل من المنشأ حتى الوجهة النهائية.

**لماذا سلسلة التبريد ضرورية؟**

كسر سلسلة التبريد ولو لفترة قصيرة قد يُفسد البضاعة بالكامل ويُعرّض المستهلك للخطر. في مصر، تعتمد قطاعات بأكملها على هذه المنظومة، من صادرات الفراولة والعنب والخضروات إلى أوروبا، إلى توزيع الأدوية واللقاحات على المحافظات، ونقل منتجات الألبان والأجبان، والاستيراد الغذائي من الدول المجاورة.

**أنواع الشاحنات المبردة**

**شاحنات التبريد العادي**

تعمل في نطاق حرارة بين درجتين مئويتين وثماني درجات، وهي مثالية للخضروات والفواكه ومنتجات الألبان والأدوية السائلة التي تحتاج للتبريد دون التجميد.

**شاحنات التجميد العميق**

تعمل في نطاق حرارة بين 18 و25 درجة تحت الصفر، وتُستخدم للأسماك والدواجن المجمدة والآيس كريم والمنتجات التي تستلزم تجميداً كاملاً.

**شاحنات متعددة الحجرات**

تنقل بضائع بدرجات حرارة مختلفة في رحلة واحدة، مما يُقلّل التكلفة ويزيد الكفاءة التشغيلية بشكل ملحوظ.

**متطلبات الشاحنة المبردة الاحترافية**

الشاحنة المبردة الاحترافية تحتاج وحدة تبريد موثوقة مع مولد احتياطي، ونظام تتبع درجة الحرارة لحظياً عبر GPS، وسجل بيانات درجة الحرارة للإثبات عند التسليم، وأبواباً عازلة محكمة الإغلاق، وعمال تحميل مدربين على الإجراءات الصحية.

**الشهادات والمعايير المطلوبة**

يستلزم نقل البضائع المبردة احترافياً الحصول على شهادة HACCP لضمان سلامة الغذاء، والالتزام بمعايير GDP للأدوية، وترخيص الهيئة العامة للرقابة على الصادرات والواردات.

شليل تمتلك أسطولاً من الشاحنات المبردة المجهزة بأحدث أنظمة التتبع، لضمان وصول بضائعك بأفضل حالة.`,
    contentEn: `The Cold Chain is an integrated system that ensures temperature-sensitive products such as fresh and frozen food, medicines, and vaccines remain at the required temperature throughout the transport journey from origin to final destination.

**Why is the Cold Chain Essential?**

Breaking the cold chain even for a short period can spoil the entire cargo and endanger the consumer. In Egypt, entire sectors depend on this system, from strawberry, grape, and vegetable exports to Europe, to the distribution of medicines and vaccines to governorates, the transport of dairy and cheese products, and food imports from neighboring countries.

**Types of Refrigerated Trucks**

**Standard Refrigerated Trucks**

Operate in a temperature range between two and eight degrees Celsius, ideal for vegetables, fruits, dairy products, and liquid medicines that need cooling without freezing.

**Deep Freeze Trucks**

Operate in a temperature range between 18 and 25 degrees below zero, used for frozen fish, poultry, ice cream, and products that require full freezing.

**Multi-Compartment Trucks**

Transport goods at different temperatures in one trip, significantly reducing cost and increasing operational efficiency.

**Professional Refrigerated Truck Requirements**

A professional refrigerated truck needs a reliable cooling unit with a backup generator, a real-time temperature tracking system via GPS, a temperature Data Logger for proof upon delivery, well-sealed insulated doors, and loading staff trained in hygiene procedures.

**Required Certificates and Standards**

Professional refrigerated cargo transport requires a HACCP certificate for food safety, GDP compliance for medicines, and a General Organization for Export and Import Control license.

Shalil operates a fleet of refrigerated trucks equipped with the latest tracking systems to ensure your goods arrive in the best condition.`,
    image: '/assets/images/hero-home-3.jpg',
    date: '2025-11-18',
    authorAr: 'فريق شليل',
    authorEn: 'Shalil Team',
    readTime: 6,
    category: 'land',
  },
  {
    id: '6',
    titleAr: 'كيف تختار شركة الشحن البري المناسبة لعملك؟',
    titleEn: 'How to Choose the Right Land Shipping Company for Your Business?',
    excerptAr: 'اختيار شريك لوجستي برّي موثوق يصنع الفارق في سرعة التوصيل وسلامة البضائع. إليك أهم المعايير.',
    excerptEn: 'Choosing a reliable land logistics partner makes the difference in delivery speed and cargo safety. Here are the most important criteria.',
    contentAr: `اختيار شركة الشحن البري المناسبة ليس قراراً عشوائياً، بل استراتيجية تؤثر مباشرة على سمعة عملك ورضا عملائك. إليك أبرز المعايير التي يجب مراعاتها:

**حجم الأسطول وتنوعه**

شركة قوية تمتلك أسطولاً متنوعاً يشمل شاحنات مبردة وناقلات بضائع ثقيلة وصهاريج وشاحنات ستائر جانبية. هذا التنوع يضمن تلبية احتياجاتك المتغيرة دون الحاجة للتعامل مع أكثر من مزود.

**التغطية الجغرافية**

تحقق من أن الشركة تغطي المحافظات والمناطق التي تحتاجها، وأن لديها شبكة موثوقة لتجاوز الحدود إلى ليبيا أو السودان أو دول الخليج إن كان ذلك ضمن متطلبات عملك.

**أنظمة التتبع**

الشركة الاحترافية توفر تتبعاً لحظياً عبر GPS لكل شحنة، مع إشعارات فورية عند أي تغيير في المسار أو التوقيت. غياب هذه الميزة يعني غياب الشفافية وصعوبة إدارة توقعات عملائك.

**خبرة فريق السائقين**

السائق المدرب والمرخص هو ضمانتك الأولى على سلامة البضاعة. تحقق من برامج التدريب التي تعتمدها الشركة وسجل السلامة لديها، فالحوادث لا تُكلّف فقط مالياً بل تُعطّل سلسلة التوريد بأكملها.

**التأمين والضمانات**

تأكد من أن وثيقة التأمين تغطي قيمة البضاعة كاملة، واسأل بوضوح عن إجراءات التعويض في حالة التلف أو الفقدان قبل توقيع أي عقد.

**الالتزام بالمواعيد**

تحقق من معدل التسليم في الوقت المحدد لدى الشركة. الشركة الجيدة تتجاوز نسبة 95% في التسليم بالموعد، وأي انخفاض عن ذلك يستوجب سؤالاً صريحاً عن الأسباب.

**خدمة العملاء**

القدرة على التواصل مع مسؤول في أي وقت والحصول على تقارير دورية دليل على احترافية الشركة واهتمامها بعلاقات طويلة الأمد مع عملائها.

في شليل للخدمات اللوجستية، نلتزم بكل هذه المعايير ونُضيف إليها خبرة عميقة في السوق المصري والإقليمي.`,
    contentEn: `Choosing the right land shipping company is not a random decision, but a strategy that directly affects your business reputation and customer satisfaction. Here are the most important criteria to consider:

**Fleet Size and Diversity**

A strong company has a diverse fleet including refrigerated trucks, heavy cargo carriers, tankers, and curtain-side trucks. This diversity ensures your changing needs are met without having to deal with more than one provider.

**Geographic Coverage**

Verify that the company covers the governorates and areas you need, and that it has a reliable network for cross-border transport to Libya, Sudan, or Gulf countries if that is within your business requirements.

**Tracking Systems**

A professional company provides real-time GPS tracking for every shipment, with instant notifications of any change in route or timing. The absence of this feature means a lack of transparency and difficulty managing your clients' expectations.

**Driver Team Experience**

A trained and licensed driver is your first guarantee of cargo safety. Check the company's training programs and safety record, as accidents are not only costly financially but also disrupt the entire supply chain.

**Insurance and Guarantees**

Make sure the insurance policy covers the full value of the goods, and ask clearly about compensation procedures in case of damage or loss before signing any contract.

**On-Time Delivery**

Check the company's on-time delivery rate. A good company exceeds 95% on-time delivery, and any drop below that warrants a direct question about the reasons.

**Customer Service**

The ability to contact a representative at any time and receive regular reports is evidence of the company's professionalism and interest in long-term relationships with its clients.

At Shalil Logistics Services, we are committed to all these criteria and add deep experience in the Egyptian and regional market.`,
    image: '/assets/images/hero-home-4.jpg',
    date: '2025-10-22',
    authorAr: 'فريق شليل',
    authorEn: 'Shalil Team',
    readTime: 6,
    category: 'land',
  },
  {
    id: '7',
    titleAr: 'الشحن البري مقابل الشحن البحري: أيهما يناسب بضاعتك؟',
    titleEn: 'Land Shipping vs Sea Shipping: Which is Right for Your Cargo?',
    excerptAr: 'مقارنة شاملة بين الشحن البري والبحري من حيث التكلفة والوقت والمرونة، لمساعدتك على اتخاذ القرار الصح لكل شحنة.',
    excerptEn: 'A comprehensive comparison between land and sea shipping in terms of cost, time, and flexibility to help you make the right decision for every shipment.',
    contentAr: `عند تخطيط أي شحنة، يواجه أصحاب الأعمال سؤالاً محورياً: هل أشحن برياً أم بحرياً؟ الإجابة ليست واحدة لجميع الحالات، بل تعتمد على عدة عوامل سنستعرضها بالتفصيل.

**متى تختار الشحن البري؟**

الشحن البري يتميز بمرونة عالية جداً في المواعيد مقارنة بالشحن البحري المقيّد بجداول السفن. يُعدّ خياراً أفضل للمسافات المتوسطة التي تقل عن ثلاثة آلاف كيلومتر، حيث يكون أسرع وغالباً أرخص عند حساب تكاليف الميناء والتفريغ. الطلبات العاجلة تُفضّل الشحن البري لأن الشاحنة تنطلق في أي وقت بينما السفينة لها جدول ثابت. كما يناسب البضائع الحساسة التي تقل فيها فرص التلف مقارنة بالشحن البحري في الطقس السيئ، وكذلك المناطق الداخلية البعيدة عن الموانئ التي تستلزم الشحن البري بكل حال.

**متى تختار الشحن البحري؟**

الشحن البحري يتفوق عند التعامل مع الكميات الكبيرة جداً، إذ تُقلّل الحاوية الكاملة التكلفة بشكل كبير مقارنة بالكميات الصغيرة. كذلك يُعدّ الخيار الأمثل للمسافات القارية الطويلة كمسارات مصر والهند أو مصر والصين، وللبضائع غير المستعجلة كالمواد الخام والسلع الاستهلاكية بكميات ضخمة، وللبضائع الثقيلة جداً التي تتجاوز خمسين طناً.

**وقت التسليم: فارق حقيقي**

لمسافة كمصر إلى المملكة العربية السعودية، يستغرق الشحن البري بين ثلاثة وخمسة أيام، بينما يحتاج الشحن البحري بين سبعة وأربعة عشر يوماً. هذا الفارق يصنع أثراً كبيراً لمن يتعامل مع بضائع ذات صلاحية محدودة أو طلبات عاجلة من عملاء.

**الحل الذكي: الجمع بين الاثنين**

النقل متعدد الوسائط يجمع مزايا الوسيلتين. بضاعة تصل بحراً إلى الإسكندرية ثم تُوزَّع برياً على المحافظات، أو صادرات مصرية تتجمع برياً من المصانع إلى ميناء العين السخنة ثم تُشحن بحراً للخليج. هذا النهج يُحقق التوازن الأمثل بين التكلفة والسرعة.

لا توجد وسيلة أفضل بالمطلق. المعيار الحقيقي هو حجم الشحنة والوجهة ومدى الاستعجال. فريق شليل يساعدك في تحليل كل حالة واختيار المزيج الأمثل.`,
    contentEn: `Business owners planning a shipment ask: land or sea? The answer depends on shipment size, destination, and urgency.

**When to Choose Land Shipping?**

Land shipping is distinguished by very high schedule flexibility compared to sea shipping, which is constrained by ship timetables. It is a better choice for medium distances of less than three thousand kilometers, where it is faster and often cheaper when factoring in port and unloading costs. Urgent orders favor land shipping because a truck can depart at any time, while a ship has a fixed schedule. It also suits sensitive goods where the chances of damage are lower compared to sea shipping in bad weather, as well as inland areas far from ports that require land transport regardless.

**When to Choose Sea Shipping?**

Sea shipping excels when dealing with very large quantities, as a full container significantly reduces cost compared to smaller quantities. It is also the ideal choice for long intercontinental distances such as Egypt-India or Egypt-China routes, for non-urgent goods like raw materials and consumer goods in bulk, and for very heavy cargo exceeding fifty tons.

**Delivery Time: A Real Difference**

For a distance like Egypt to Saudi Arabia, land shipping takes three to five days, while sea shipping needs seven to fourteen days. This difference has a significant impact for those dealing with goods with limited shelf life or urgent customer orders.

**The Smart Solution: Combining Both**

Multimodal transport combines the advantages of both modes. Goods arrive by sea to Alexandria and are then distributed overland to governorates, or Egyptian exports are collected overland from factories to Ain Sokhna Port and then shipped by sea to the Gulf. This approach achieves the optimal balance between cost and speed.

There is no single best transport mode. The real criteria are the shipment volume, destination, and urgency. The Shalil team helps you analyze each case and choose the optimal mix.`,
    image: '/assets/images/hero-home-5.jpg',
    date: '2026-04-10',
    authorAr: 'فريق شليل',
    authorEn: 'Shalil Team',
    readTime: 7,
    category: 'land',
  },
  {
    id: '8',
    titleAr: 'ممرات الشحن الاستراتيجية: باب المندب وهرمز والسويس وتأثيرها على التجارة',
    titleEn: 'Strategic Shipping Chokepoints: Bab el-Mandeb, Hormuz and Suez and Their Impact on Trade',
    excerptAr: 'ثلاثة ممرات مائية تتحكم في نبض التجارة العالمية. تعرف على أهمية كل واحد منها وكيف تؤثر التوترات فيها على تكاليف الشحن وأسعار السلع.',
    excerptEn: 'Three waterways control the pulse of global trade. Learn about the importance of each one and how tensions in them affect shipping costs and commodity prices.',
    contentAr: `تُهيمن ثلاثة ممرات مائية على ما يزيد عن أربعين بالمئة من حجم التجارة البحرية العالمية. فهم ديناميكياتها ليس ترفاً أكاديمياً، بل ضرورة لكل مستورد ومصدر وصاحب قرار لوجستي.

**مضيق باب المندب**

يقع مضيق باب المندب بين جيبوتي وجنوب اليمن عند مدخل البحر الأحمر من الجهة الجنوبية، ولا يتجاوز عرض أضيق نقطة فيه تسعة وعشرين كيلومتراً. يمر عبره نحو خمسة ملايين برميل نفط يومياً إلى جانب مئات السفن التجارية، مما يجعله بوابة حيوية تستأثر بنحو عشرة بالمئة من التجارة البحرية العالمية.

باب المندب هو الممر الوحيد بين المحيط الهندي والبحر الأحمر باتجاه قناة السويس. أي اضطراب في هذا الممر يعني إعادة توجيه السفن حول رأس الرجاء الصالح بما يُضيف من اثنتي عشرة إلى خمس عشرة يوماً على أوقات الشحن، ويرفع تكاليف الوقود بنسبة تتراوح بين خمسة عشر وعشرين بالمئة، علاوة على ارتفاع أسعار التأمين البحري وتأخر وصول البضائع إلى أوروبا وشمال أفريقيا.

وكلما ارتفعت تكاليف الإبحار عبر باب المندب، ازداد الطلب على الحلول البرية عبر مصر كمسار بديل أكثر استقراراً وقدرة على التنبؤ.

**مضيق هرمز**

يقع مضيق هرمز بين عُمان وإيران عند مخرج الخليج العربي، ولا تتجاوز منطقة الممر الملاحي المستخدمة ثلاثة كيلومترات ونصف في أضيق نقطة. يمر عبره نحو عشرين بالمئة من نفط العالم، ما يعادل نحو ثمانية عشر مليون برميل يومياً، وهو ما يمثل ثلث التجارة البحرية للنفط المسال في العالم.

دول الخليج كالمملكة العربية السعودية والإمارات والكويت والعراق لا طريق بحرياً لها للتصدير إلا عبره. أي توتر في المنطقة يُرسل موجة صدمة فورية لأسواق النفط العالمية ويرفع تكلفة الشحن البحري من الخليج، مما يدفع بعض المستوردين للبحث عن مسارات برية بديلة عبر المملكة العربية السعودية والأردن ومصر.

**قناة السويس**

قناة السويس هي الممر الاصطناعي الذي شيّدته مصر وتديره، وتربط البحر الأحمر بالبحر الأبيض المتوسط مختصرةً نحو سبعة آلاف كيلومتر مقارنة بطريق رأس الرجاء الصالح. تستأثر القناة بما بين اثني عشر وخمسة عشر بالمئة من التجارة البحرية العالمية، وقد عبرتها أكثر من خمسة وعشرين ألف سفينة عام 2023 وحده، مما أدر على مصر قرابة تسعة مليارات ونصف من الدولارات.

أثبتت حادثة جنوح سفينة إيفر غيفن عام 2021 لمدة ستة أيام فقط هشاشة هذا الاعتماد، إذ تجاوزت الخسائر في حركة التجارة العالمية ستين مليار دولار خلال تلك الأيام القليلة.

**الأثر المشترك على الشحن البري المصري**

الاضطرابات في هذه الممرات الثلاثة لا تُحوّل البضائع تلقائياً إلى الشحن البري، لكنها ترفع تكلفة البديل البحري وتجعل الحل البري أكثر جاذبية اقتصادياً. مصر بموقعها الجغرافي تقع في مركز هذه المنظومة وتملك أدوات للاستفادة من كل اضطراب يصيب أياً من هذه الممرات، سواء من خلال تقديم مسارات برية داخلية أو من خلال تسهيل العبور متعدد الوسائط بين البحرين.

مستقبل اللوجستيات المصرية يكمن في تحويل هذه التوترات الإقليمية إلى فرص تنموية حقيقية.`,
    contentEn: `Understanding their dynamics is a necessity for every importer, exporter, and logistics decision-maker.

**Bab el-Mandeb Strait**

Bab el-Mandeb Strait is located between Djibouti and southern Yemen at the southern entrance of the Red Sea, with the narrowest point not exceeding twenty-nine kilometers wide. Around five million barrels of oil pass through it daily alongside hundreds of commercial vessels, making it a vital gateway that accounts for approximately ten percent of global maritime trade.

Bab el-Mandeb is the only passage between the Indian Ocean and the Red Sea toward the Suez Canal. Any disruption in this strait means rerouting ships around the Cape of Good Hope, adding twelve to fifteen days to shipping times and raising fuel costs by fifteen to twenty percent, in addition to rising maritime insurance prices and delays in goods reaching Europe and North Africa.

The higher the cost of sailing through Bab el-Mandeb, the greater the demand for overland solutions through Egypt as a more stable and predictable alternative route.

**Strait of Hormuz**

The Strait of Hormuz is located between Oman and Iran at the exit of the Arabian Gulf, with the usable shipping lane not exceeding three and a half kilometers at its narrowest point. About twenty percent of the world's oil passes through it, equivalent to approximately eighteen million barrels daily, representing one-third of the world's liquefied natural gas maritime trade.

Gulf countries such as Saudi Arabia, the UAE, Kuwait, and Iraq have no maritime export route except through it. Any tension in the region sends an immediate shockwave to global oil markets and raises the cost of sea shipping from the Gulf, pushing some importers to seek overland alternative routes via Saudi Arabia, Jordan, and Egypt.

**Suez Canal**

The Suez Canal is the artificial waterway built and operated by Egypt, connecting the Red Sea to the Mediterranean Sea and cutting approximately seven thousand kilometers compared to the Cape of Good Hope route. The canal accounts for between twelve and fifteen percent of global maritime trade, with more than twenty-five thousand ships transiting it in 2023 alone, generating approximately nine and a half billion dollars for Egypt.

The 2021 grounding incident of the Ever Given for just six days proved the fragility of this dependence, as losses in global trade traffic exceeded sixty billion dollars during those few days.

**The Combined Impact on Egyptian Land Shipping**

Disruptions in these three chokepoints do not automatically redirect cargo to land shipping, but they raise the cost of the maritime alternative and make the land solution more economically attractive. Egypt, with its geographic position at the center of this system, has the tools to benefit from any disruption affecting any of these passages, whether through providing domestic overland routes or facilitating multimodal transit between the two seas.

The future of Egyptian logistics lies in converting these regional tensions into genuine development opportunities.`,
    image: '/assets/images/hero-home-6.jpg',
    date: '2026-05-01',
    authorAr: 'فريق شليل',
    authorEn: 'Shalil Team',
    readTime: 9,
    category: 'land',
  },
  {
    id: '9',
    titleAr: 'أسعار الشحن البري: كيف تُحسب وكيف تُخفّضها؟',
    titleEn: 'Land Freight Pricing: How Is It Calculated and How Can You Reduce It?',
    excerptAr: 'تكشف عن العوامل الخفية التي تُشكّل سعر الشحنة البرية، وتعرّف على الاستراتيجيات الذكية لخفض تكاليف النقل دون المساس بالجودة.',
    excerptEn: 'Uncover the hidden factors that shape land freight pricing, and learn smart strategies to reduce transport costs without compromising quality.',
    contentAr: `كثير من أصحاب الأعمال يتلقّون عروض أسعار شحن متفاوتة دون أن يفهموا ما يُشكّل الفارق. هذا المقال يكشف آلية التسعير بالتفصيل ويُقدّم نصائح عملية لخفض التكاليف.

**المسافة والمسار**

الكيلومتر هو الوحدة الأساسية للتسعير، لكن ليس كل الكيلومترات متساوية. الطرق السريعة المُصانة تعني تكلفة أقل وزمناً أقصر، بينما الطرق الجبلية أو الوعرة ترفع التكلفة بسبب استهلاك الوقود والوقت الإضافي. عبور الحدود يُضيف رسوماً جمركية وتصاريح تُحسب بشكل منفصل.

**الوزن الحجمي**

الشحن البري يعتمد على الوزن الفعلي أو الوزن الحجمي أيهما أكبر. الوزن الحجمي يُحسب بضرب أبعاد البضاعة بالسنتيمتر ثم قسمة الناتج على خمسة آلاف. صناديق فارغة كبيرة مثلاً قد تدفع ضعف سعر بضاعة صغيرة كثيفة الوزن لأن الوزن الحجمي يتجاوز الفعلي.

**نوع البضاعة وتأثيره على السعر**

البضاعة العادية تُسعَّر بالمعيار الأساسي. البضائع المبردة أو المجمدة تُضيف بين خمسة وعشرين وأربعين بالمئة بسبب تكاليف التبريد. البضائع الخطرة أو الكيميائية تتطلب تأميناً خاصاً يرفع السعر بين ثلاثين وخمسين بالمئة. البضائع الضخمة أو عالية القيمة تُحسب حسب الحالة.

**الشاحنة الكاملة أم الشحن الجزئي**

في الشاحنة الكاملة تدفع للشاحنة بأكملها بغض النظر عن الملء الفعلي، وهو خيار أرخص للكميات الكبيرة التي تملأ أكثر من سبعين بالمئة من الحمولة. في الشحن الجزئي تدفع فقط عن حجمك وهو مناسب للكميات الصغيرة، لكن وقت التوصيل قد يكون أطول بسبب التوقفات الوسيطة.

**توقيت الشحن**

مواسم الذروة كالأعياد ونهاية العام ترفع الأسعار بسبب الطلب المرتفع. الحجز المسبق دائماً أوفر من الطلب اللحظي، وأحياناً الشحن منتصف الأسبوع يكون أرخص من طرفيه.

**تكاليف الانتظار**

إذا تأخّر التحميل أو التفريغ عن الموعد المتفق تُفرض رسوم انتظار ساعية. تجنّبها بإعداد البضاعة قبل وصول الشاحنة وتنسيق مسبق مع موقع التسليم.

**استراتيجيات ذكية لخفض التكاليف**

دمج الشحنات الصغيرة في دورات أسبوعية أو شهرية يُقلّل التكلفة بشكل ملحوظ. منح الناقل مرونة في المواعيد عند الشحنات غير العاجلة يُخفّض السعر في أغلب الأحيان. العقود السنوية مع شركة نقل موثوقة تمنح خصومات تتراوح بين عشرة وخمسة وعشرين بالمئة. تحسين التغليف وتقليل الهواء داخل الصناديق يُخفّض الوزن الحجمي ويوفّر على المدى الطويل.

مقارنة عملية لنقل خمسة أطنان من القاهرة إلى الرياض: الشحن الجوي يُكلّف نحو ثمانية عشر ألف دولار ويصل في يوم أو يومين، والشحن البحري نحو ثلاثة آلاف وخمسمئة دولار ويصل بين عشرة وخمسة عشر يوماً، والشحن البري نحو ألفين وثمانمئة دولار ويصل بين أربعة وستة أيام. هذه أرقام تقريبية تتغير مع أسعار السوق.

لا يوجد سعر ثابت للشحن البري. كل شحنة لها تركيبة تسعير خاصة. التواصل المبكر مع شركة موثوقة وتقديم كافة التفاصيل يُتيح الحصول على أفضل سعر ممكن.`,
    contentEn: `Many business owners receive varying freight quotes without understanding what drives the difference. This article reveals the pricing mechanism in detail and offers practical tips to reduce costs.

**Distance and Route**

The kilometer is the fundamental pricing unit, but not all kilometers are equal. Well-maintained highways mean lower cost and shorter time, while mountain or rough roads raise the cost due to extra fuel consumption and time. Border crossings add customs fees and permits that are calculated separately.

**Volumetric Weight**

Land shipping uses actual weight or volumetric weight, whichever is greater. Volumetric weight is calculated by multiplying the cargo dimensions in centimeters and then dividing the result by five thousand. Large empty boxes, for example, may cost twice as much as a small, dense, heavy shipment because the volumetric weight exceeds the actual weight.

**Type of Goods and Its Price Impact**

Standard goods are priced at the baseline rate. Refrigerated or frozen goods add between twenty-five and forty percent due to cooling costs. Hazardous or chemical goods require special insurance that raises the price by thirty to fifty percent. Oversized or high-value goods are calculated on a case-by-case basis.

**Full Truck or Partial Shipment**

With a full truck you pay for the entire truck regardless of actual fill, which is a cheaper option for large quantities that fill more than seventy percent of the load capacity. With partial shipment you pay only for your space, which suits small quantities, but delivery time may be longer due to intermediate stops.

**Shipping Timing**

Peak seasons like holidays and year-end raise prices due to increased demand. Pre-booking is always more economical than last-minute requests, and sometimes mid-week shipping is cheaper than the beginning or end of the week.

**Waiting Costs**

If loading or unloading is delayed past the agreed time, hourly waiting fees apply. Avoid them by preparing goods before the truck arrives and coordinating in advance with the delivery location.

**Smart Strategies to Reduce Costs**

Consolidating small shipments into weekly or monthly cycles significantly reduces cost. Giving the carrier schedule flexibility for non-urgent shipments usually lowers the price. Annual contracts with a trusted shipping company provide discounts ranging from ten to twenty-five percent. Improving packaging and reducing air inside boxes decreases volumetric weight and saves money over time.

A practical comparison for transporting five tons from Cairo to Riyadh: air freight costs around eighteen thousand dollars and arrives in one to two days, sea freight costs around three thousand five hundred dollars and arrives in ten to fifteen days, and land freight costs around two thousand eight hundred dollars and arrives in four to six days. These are approximate figures that change with market prices.

There is no fixed price for land shipping. Every shipment has its own pricing composition. Communicating early with a trusted company and providing all details allows you to get the best possible price.`,
    image: '/assets/images/hero-home-7.jpg',
    date: '2026-06-01',
    authorAr: 'فريق شليل',
    authorEn: 'Shalil Team',
    readTime: 8,
    category: 'land',
  },
]
